// functions that are use on page EditZones.js to draw new zones

function formatCoordinates(canvas, rect, x, y) {
  const scaleX = canvas.width / rect.width;
  const scaleY = canvas.height / rect.height;
  const currentCoordinates = {
    x: (x - rect.left) * scaleX,
    y: (y - rect.top) * scaleY,
  };

  return currentCoordinates;
}

function cleanCanvas(context, canvas) {
  context.clearRect(0, 0, canvas.width, canvas.height);
}

function drawLine(context, color, x1, y1, x2, y2, width = 3) {
  context.lineWidth = width;
  context.strokeStyle = color;
  context.lineCap = "round";

  context.beginPath();
  context.moveTo(x1, y1);
  context.lineTo(x2, y2);
  context.stroke();
}

function drawCircle(context, color, radius, x, y) {
  context.strokeStyle = color;

  context.beginPath();
  context.arc(x, y, radius, 0, 2 * Math.PI);
  context.fillStyle = color;
  context.fill();
  context.stroke();
}

function drawAlignedRect(context, x1, y1, x2, y2, width = 50) {
  const length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  const angle = Math.atan2(y2 - y1, x2 - x1);

  context.save();
  context.translate(x1, y1);
  context.rotate(angle);

  context.lineWidth = 3;

  const color1 = "#FF00FF";
  const color2 = "#FF00FF";

  context.lineWidth = 3;

  context.strokeStyle = color1;
  context.strokeRect(0, 3, length, width);

  context.strokeStyle = color2;
  context.strokeRect(0, -3, length, -width);

  context.restore();
}

function drawCoordinates(
  context,
  zones,
  editMode,
  zoneBeingEdited,
  canvas,
  clean = true
) {
  if (clean) {
    cleanCanvas(context, canvas);
  }

  zones.forEach((zone) => {
    zone.coordinates.forEach((coordinate) => {
      const x1y1 = {
        x: coordinate[0].x,
        y: coordinate[0].y,
      };
      const x2y2 = {
        x: coordinate[1].x,
        y: coordinate[1].y,
      };

      const color =
        editMode && zone.id !== zoneBeingEdited ? "gray" : zone.color;

      const zoneLineWidth = 2.5;
      drawLine(context, color, x1y1.x, x1y1.y, x2y2.x, x2y2.y, zoneLineWidth);

      if (editMode && zone.id === zoneBeingEdited) {
        drawCircle(context, color, 4, x2y2.x, x2y2.y);
      }
    });
  });
}

function drawArrow(context, x, y, angle, color) {
  const arrowLength = 36;
  const arrowWidth = 14;
  const headLength = 18;

  context.save();
  context.translate(x, y);
  context.rotate(angle);

  context.beginPath();
  context.moveTo(0, -arrowWidth / 2);
  context.lineTo(arrowLength - headLength, -arrowWidth / 2);
  context.lineTo(arrowLength - headLength, -arrowWidth);
  context.lineTo(arrowLength, 0);
  context.lineTo(arrowLength - headLength, arrowWidth);
  context.lineTo(arrowLength - headLength, arrowWidth / 2);
  context.lineTo(0, arrowWidth / 2);
  context.closePath();

  context.fillStyle = color;
  context.fill();

  context.restore();
}

function drawLineCoordinates(
  context,
  lines,
  editMode,
  lineBeingEdited,
  canvas,
  clean = true,
  showDirectionArrows = false,
  directionLineId = null
) {
  if (clean) {
    cleanCanvas(context, canvas);
  }

  lines.forEach((line) => {
    line.coordinates.forEach((coordinate) => {
      const point1 = coordinate[0];
      const point2 = coordinate[1];

      const color =
        editMode && line.id !== lineBeingEdited ? "gray" : line.color;

      drawLine(context, color, point1.x, point1.y, point2.x, point2.y, 3);

      if (showDirectionArrows && directionLineId === line.id) {
        const midX = (point1.x + point2.x) / 2;
        const midY = (point1.y + point2.y) / 2;
        const angle = Math.atan2(point2.y - point1.y, point2.x - point1.x);
        drawArrow(context, midX, midY, angle + Math.PI / 2, "#2979FF");
        drawArrow(context, midX, midY, angle - Math.PI / 2, "#8F00FF");
      }

      if (editMode && line.id === lineBeingEdited) {
        drawCircle(context, color, 4, point1.x, point1.y);
        drawCircle(context, color, 4, point2.x, point2.y);
      }
    });
  });
}

function checkProximity(x1, y1, x2, y2) {
  const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  return distance < 10;
}

function checkVerticeProximity(x1, y1, x2, y2) {
  return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2) < 4;
}

function checkZoneCrossOther(zone, zones) {
  const EPS = 1e-6;

  const isValidPoint = (point) =>
    point && Number.isFinite(point.x) && Number.isFinite(point.y);

  const getPolygonVertices = (polygonZone) =>
    (polygonZone?.coordinates || [])
      .map((segment) => segment?.[0])
      .filter(isValidPoint);

  const orientation = (a, b, c) =>
    (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x);

  const onSegment = (a, b, p) =>
    p.x >= Math.min(a.x, b.x) - EPS &&
    p.x <= Math.max(a.x, b.x) + EPS &&
    p.y >= Math.min(a.y, b.y) - EPS &&
    p.y <= Math.max(a.y, b.y) + EPS;

  const isPointOnSegment = (point, start, end) => {
    const cross = orientation(start, end, point);
    if (Math.abs(cross) > EPS) return false;
    return onSegment(start, end, point);
  };

  const isPointOnPolygonBoundary = (point, polygonVertices) => {
    for (let i = 0; i < polygonVertices.length; i += 1) {
      const start = polygonVertices[i];
      const end = polygonVertices[(i + 1) % polygonVertices.length];
      if (isPointOnSegment(point, start, end)) {
        return true;
      }
    }
    return false;
  };

  const hasProperSegmentIntersection = (a1, a2, b1, b2) => {
    const o1 = orientation(a1, a2, b1);
    const o2 = orientation(a1, a2, b2);
    const o3 = orientation(b1, b2, a1);
    const o4 = orientation(b1, b2, a2);

    // Proper crossing (ignores shared endpoints/edges)
    if (o1 * o2 < -EPS && o3 * o4 < -EPS) {
      return true;
    }

    return false;
  };

  const isPointStrictlyInsidePolygon = (point, polygonVertices) => {
    if (!point || polygonVertices.length < 3) return false;
    if (isPointOnPolygonBoundary(point, polygonVertices)) return false;
    let inside = false;

    for (
      let i = 0, j = polygonVertices.length - 1;
      i < polygonVertices.length;
      j = i++
    ) {
      const xi = polygonVertices[i].x;
      const yi = polygonVertices[i].y;
      const xj = polygonVertices[j].x;
      const yj = polygonVertices[j].y;

      const intersects =
        yi > point.y !== yj > point.y &&
        point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;

      if (intersects) inside = !inside;
    }

    return inside;
  };

  if (!zone || !Array.isArray(zones)) return false;

  const zoneVertices = getPolygonVertices(zone);
  if (zoneVertices.length < 3) return false;

  for (const otherZone of zones) {
    if (!otherZone || otherZone.id === zone.id) continue;

    const otherVertices = getPolygonVertices(otherZone);
    if (otherVertices.length < 3) continue;

    // Edge crossing / overlap
    for (const segmentA of zone.coordinates || []) {
      const a1 = segmentA?.[0];
      const a2 = segmentA?.[1];
      if (!isValidPoint(a1) || !isValidPoint(a2)) continue;

      for (const segmentB of otherZone.coordinates || []) {
        const b1 = segmentB?.[0];
        const b2 = segmentB?.[1];
        if (!isValidPoint(b1) || !isValidPoint(b2)) continue;

        if (hasProperSegmentIntersection(a1, a2, b1, b2)) {
          return true;
        }
      }
    }

    // Containment without edge crossing (strictly inside only)
    if (
      zoneVertices.some((point) =>
        isPointStrictlyInsidePolygon(point, otherVertices)
      ) ||
      otherVertices.some((point) =>
        isPointStrictlyInsidePolygon(point, zoneVertices)
      )
    ) {
      return true;
    }
  }

  return false;
}

function handleNewLine(
  event,
  canvas,
  currentClick,
  currentColor,
  drawMode,
  zones,
  zoneBeingEdited,
  lines,
  lineBeingEdited,
  editMode
) {
  const rect = canvas.getBoundingClientRect();
  const context = canvas.getContext("2d");

  const currentCoordinates = formatCoordinates(
    canvas,
    rect,
    event.clientX,
    event.clientY
  );

  context.clearRect(0, 0, canvas.width, canvas.height);
  if (drawMode === "zone") {
    drawCoordinates(context, zones, editMode, zoneBeingEdited, canvas);
  } else if (drawMode === "line") {
    drawLineCoordinates(context, lines, editMode, lineBeingEdited, canvas);
  }
  drawLine(
    context,
    currentColor,
    currentClick.x,
    currentClick.y,
    currentCoordinates.x,
    currentCoordinates.y,
    drawMode === "zone" ? 2.5 : 3
  );
}

function checkProximityWithOtherZones(currentCoordinates, zones, currentId) {
  for (let zone of zones) {
    if (zone.id !== currentId) {
      for (let coordinateArray of zone.coordinates) {
        for (let vertex of coordinateArray) {
          const x1 = vertex.x;
          const y1 = vertex.y;

          if (
            checkVerticeProximity(
              x1,
              y1,
              currentCoordinates.x,
              currentCoordinates.y
            )
          ) {
            currentCoordinates.x = x1;
            currentCoordinates.y = y1;
            return true;
          }
        }
      }
    }
  }
  return false;
}

export {
  formatCoordinates,
  cleanCanvas,
  drawLine,
  drawCircle,
  drawAlignedRect,
  drawCoordinates,
  drawLineCoordinates,
  checkProximity,
  checkVerticeProximity,
  checkZoneCrossOther,
  handleNewLine,
  checkProximityWithOtherZones,
  drawArrow,
};
